import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { articles } from "@/data/articles";

const accentMap = {
    brand: "bg-brand-500",
    pinky: "bg-pinky-500",
    ink: "bg-ink-800",
};

export default function Articles() {
    const previews = articles.slice(0, 3);
    return (
        <section
            id="articles"
            data-testid="articles-section"
            className="py-24 sm:py-32 bg-white"
        >
            <div className="container-wide">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6">
                    <div className="max-w-2xl">
                        <span className="eyebrow-brand">Ressources gratuites</span>
                        <h2 data-testid="articles-title" className="display-2 mt-4">
                            Tips &amp; Articles.
                        </h2>
                        <p className="body-lg mt-5">
                            Des conseils pratiques basés sur notre méthodologie pour commencer dès aujourd'hui.
                        </p>
                    </div>
                </div>

                <div className="mt-16 grid md:grid-cols-3 gap-6">
                    {previews.map((a, i) => (
                        <Link
                            to={`/articles/${a.slug}`}
                            key={a.slug}
                            data-testid={`article-card-${i}`}
                            className="group soft-card overflow-hidden transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_-30px_rgba(15,23,42,0.25)]"
                        >
                            <div className="relative aspect-[5/4] overflow-hidden">
                                <img
                                    src={a.img}
                                    alt={a.title}
                                    className="w-full h-full object-cover transition-transform duration-[1100ms] group-hover:scale-[1.06]"
                                />
                                <span
                                    className={`absolute top-5 left-5 inline-block text-[10px] font-semibold uppercase tracking-[0.18em] ${accentMap[a.accent]} text-white px-3 py-1.5 rounded-full`}
                                >
                                    {a.category}
                                </span>
                            </div>
                            <div className="p-7 sm:p-8">
                                <h3 className="font-display font-semibold text-xl text-ink-900 leading-snug">
                                    {a.title}
                                </h3>
                                <p className="mt-3 text-ink-600 leading-relaxed text-sm">{a.excerpt}</p>
                                <div className="mt-6 flex items-center justify-between">
                                    <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-wider text-ink-500">
                                        <Clock className="h-3.5 w-3.5" strokeWidth={2} /> {a.readTime}
                                    </span>
                                    <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600 group-hover:text-brand-700">
                                        Lire l'article
                                        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={2} />
                                    </span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <Link
                        to="/articles"
                        data-testid="articles-view-all"
                        className="btn-ghost text-sm font-semibold"
                    >
                        Voir tous les articles <ArrowRight className="ml-1 h-4 w-4" strokeWidth={2} />
                    </Link>
                </div>
            </div>
        </section>
    );
}
